import React, { useState, useEffect } from "react";
import { Select, Spin } from "antd";
import useHttp from "../../hooks/use-http";
import DynamicBarChart from "../barChart";
import DynamicColumnChart from "../columnChart";
import DynamicLineChart from "../lineChart";
import DynamicPieChart from "../pieChart";

const { Option } = Select;

const FieldExecutive = ({
  chartTitle = "Field Executives per Region"
}) => {
  const [chartType, setChartType] = useState("pie");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    const url = `/api/fieldExecutivePerRegion/?orgId=${localStorage.getItem("orgId")}&userId=${localStorage.getItem("id")}`;
    getData(
      { url },
      (res) => {
        if (res && res.regions) {
          // Prepare data: one record per executive per region
          const flattened = [];
          res.regions.forEach(region => {
            if (region.executives) {
              region.executives.forEach(exec => {
                flattened.push({
                  regionName: region.regionName,
                  executiveName: exec.executiveName,
                  executiveId: exec.executiveId,
                });
              });
            }
          });
          // For count, you can also prepare data:
          const counts = res.regions.map(region => ({
            regionName: region.regionName,
            executiveCount: region.executiveCount
          }));

          setData({ flattened, counts });
        } else {
          setData({ flattened: [], counts: [] });
        }
        setLoading(false);
      }
    );
  }, [getData]);

  const handleChartChange = (value) => setChartType(value);

  // Choose which type of chart you want: unique names or counts
  // For most categorical charts, show the count/bar as the main view
  const chartData = data.counts || [];
  const execsData = data.flattened || [];

  return (
    <div className="bg-white rounded-2xl shadow-md p-4">
      <div className="flex justify-between items-center mb-4">
        {/* <h4 className="text-lg font-semibold">{chartTitle}</h4> */}
        <Select value={chartType} style={{ width: 120 }} onChange={handleChartChange}>
          <Option value="column">Column</Option>
          <Option value="bar">Bar</Option>
          <Option value="line">Line</Option>
          <Option value="pie">Pie</Option>
        </Select>
      </div>
      {loading ? (
        <div className="flex justify-center"><Spin /></div>
      ) : (
        <>
          {chartType === "column" && (
            <DynamicColumnChart
              data={chartData}
              xField="regionName"
              yField="executiveCount"
              xAxisTitle="Region"
              yAxisTitle="Executive Count"
            />
          )}
          {chartType === "bar" && (
            <DynamicBarChart
              data={chartData}
              xField="regionName"
              yField="executiveCount"
              xAxisTitle="Region"
              yAxisTitle="Executive Count"
            />
          )}
          {chartType === "line" && (
            <DynamicLineChart
              data={chartData}
              xField="regionName"
              yField="executiveCount"
              xAxisTitle="Region"
              yAxisTitle="Executive Count"
            />
          )}
          {chartType === "pie" && (
            <DynamicPieChart
              data={chartData}
              angleField="executiveCount"
              colorField="regionName"
            />
          )}
        </>
      )}
    </div>
  );
};

export default FieldExecutive;
